import type { GridSortModel } from "@mui/x-data-grid-premium";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { selectListFields, selectSorts } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import { rebuildSortingFields, type SortingFieldModel } from "../../../tabular/preview/rebuildSortingFields.ts";
import { getSortModel } from "../../utils/listSortHelper.ts";

interface ListSortingResult {
  sortModel: GridSortModel;
  onSortingChanged: (model: SortingFieldModel) => void;
}

const useListSorting = (): ListSortingResult => {
  const dispatch = useAppDispatch();
  const listFields = useSelector(selectListFields);
  const sortFields = useSelector(selectSorts);

  const sortModel = useMemo(() => getSortModel(sortFields), [sortFields]);
  const onSortingChanged = useCallback(
    (model: SortingFieldModel) => {
      const sorts = rebuildSortingFields(model, listFields, sortFields);
      dispatch(fieldsStateActions.setSorting({ fields: sorts, groupMetaNames: [] }));
    },
    [dispatch, listFields, sortFields]
  );

  return { sortModel, onSortingChanged };
};

export default useListSorting;
